import Header from "../../components/dashboard/header"
import { Breadcrumb,Button,Input,Modal,Popconfirm,message,Space,Form, InputNumber,Spin, Checkbox } from "antd";
import { Link } from "react-router-dom";
import { PlusSquareOutlined,DashboardOutlined,DollarCircleOutlined,DeleteOutlined,EditOutlined } from "@ant-design/icons";
import {AiOutlineSetting} from "react-icons/ai";
import DataTable from "../../components/common/table";
import { PERCENT } from "../../defaults/utilities";
import {useRef, useState,useEffect, useContext} from "react";
import { extractValueFromInputRef,scrollToTop } from "../../helpers/dom";
import { useCreateTax, useDeleteTax, useGetAllTaxes, useUpdateTax } from "../../hooks/tax/taxQuery";
import RefreshContext from "../../context/refreshContext";



export const DUMMY_TAXES_DATA = [
    {
        id:"1",
        key:"1",
        title:"FGN Tax",
        percentage:1.2,
    },
    {
        id:"2",
        key:"2",
        title:"Internet Charges",
        percentage:3
    },
    {
        id:"3",
        key:"3",
        title:"Bursary Charges",
        percentage:2
    }
];


export const taxesDataColumn = [
    {
        title:"S/N",
        key:'id',
        render:(_,__,idx)=>idx+1
    },
    {
        title:"Tax",
        key:"title",
        dataIndex:"title"
    },
    {
        title:"Percentage",
        dataIndex:"charge",
        key:"charge",
        render:(_,{charge})=>`${charge}${PERCENT}`
    },
    {
        title:"Actions",
        key:"actions",
        render:(_,tax)=><TaxesEdit tax={tax}/>
    }
]



function TaxesEdit({tax}){
    const [isOpen,setIsOpen] = useState(false);
    const [isChecked,setChecked] = useState(tax.applyToPayroll)

    const titleRef = useRef(null);
    const chargeRef = useRef(null);

    const handleOpen = ()=> setIsOpen(true);
    const handleClose = ()=>setIsOpen(false);

    const updateTax = useUpdateTax();
    const deleteTax = useDeleteTax();

    const confirmDelete = async()=>{
    
        const {message:response} = await deleteTax(tax.id);
        message.success(response ?? "Tax deleted successfully");
    };

    const handleSubmit = async ()=>{
        const payload = {
            title:extractValueFromInputRef(titleRef),
            charge:chargeRef.current.value
        }
        const {message:response} = await updateTax(tax.id,payload);
        message.success(response??"Tax update successfully");
        setIsOpen(false);
    }

    return(
        <>
          <Space size="small" wrap>
                <Button type="primary" onClick={handleOpen}>
                    <EditOutlined />
                    Edit
                </Button>
                <Popconfirm
                     title="Delete this Tax"
                     description="Are you sure to delete this tax?"
                     onConfirm={confirmDelete}
                    onCancel={()=>null}
                    okText="Yes"
                    cancelText="No"
                     >
                    <Button type="primary" danger>
                        <DeleteOutlined />
                        Delete
                    </Button>
                </Popconfirm>
            </Space>
            <Modal title="Edit Tax" footer={null} open={isOpen} onCancel={handleClose}>
                <Form initialValues={{...tax}}>
                    <Form.Item name={'title'}>
                        <Input placeholder="enter percentage name" ref={titleRef}/>
                    </Form.Item>
                    <Form.Item name={'charge'}>
                        <InputNumber placeholder="enter percentage figure" ref={chargeRef} style={{width:"100%"}} addonAfter={PERCENT}/>
                    </Form.Item>
                    <Form.Item>
                        <Checkbox checked={isChecked} onChange={(e)=>setChecked(e.target.checked)}>
                            Add to Payroll
                        </Checkbox>
                    </Form.Item>
                    <Form.Item wrapperCol={{
                        span:8,
                        offset:20
                      }}>
                        <Button type="primary" onClick={handleSubmit}>
                            update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}



export default function TaxConfig(){
    const [isOpen,setIsOpen] = useState(false);
    const [isChecked,setChecked] = useState(false);
    
    const handleOpen = ()=>setIsOpen(true);
    const handleClose = ()=>setIsOpen(false);
    const taxRef = useRef(null);
    const percentageRef = useRef(null);

    const {flag,setFlag} = useContext(RefreshContext);

    useEffect(()=>{
        scrollToTop();
    },[]);

    const createTax =  useCreateTax();

    const {loading,taxes} = useGetAllTaxes(flag);

    const handleSubmit = async ()=>{
        const payload = {
            title:extractValueFromInputRef(taxRef),
            applyToPayroll:isChecked,
            charge:percentageRef.current.value,
        }
        const {message:response} = await createTax(payload);
        message.success(response??"tax creates successfully");
        setFlag(!flag);
        setIsOpen(false);
    }


    return(
        <>
              
              <div className="main-container">
                <Header/>
                <div className="main-body">
                    
                    <div className="info-bar">
                    <Breadcrumb>
                        <Breadcrumb.Item>
                        <DashboardOutlined className="dashboard-icon"/>
                        <Link to={"/dashboard"}>Dashboard</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                        <AiOutlineSetting/> 
                        <Link to={"/dashboard"}>Configuration</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                         <DollarCircleOutlined/>
                            <Link to="/dashboard/tax-config">Taxes</Link>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{display:'flex',gap:'1em'}}>
                            <Button style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={handleOpen}>
                            <PlusSquareOutlined />
                                Add Tax
                            </Button>
                        </div>
                    </div>
                
                    <div className="table-section">
                        <Spin spinning={loading}>
                        <DataTable cols={taxesDataColumn} data={taxes}/>
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal title="Create a Tax" footer={null} open={isOpen} onCancel={handleClose}>
                <Form>
                    <Form.Item name="title">
                        <Input placeholder="enter percentage name" ref={taxRef}/>
                    </Form.Item>
                    <Form.Item name="percentage">
                        <InputNumber placeholder="enter percentage figure" style={{width:"100%"}} ref={percentageRef}/>
                    </Form.Item>
                    <Form.Item>
                        <Checkbox onChange={(e)=>setChecked(e.target.checked)}>
                            Add to Payroll
                        </Checkbox>
                    </Form.Item>
                    <Form.Item wrapperCol={{
                        span:8,
                        offset:20
                      }}>
                        <Button type="primary" onClick={handleSubmit}>
                            Create
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}